import { useService } from "../../../hooks";
import { useUnitGeneric } from "./useUnitGeneric";

export const useUnit = (passedUnitId?: number) => {
  const { getUnit } = useService();
  return useUnitGeneric(getUnit, passedUnitId);
};